export default __webpack_public_path__ + "static/media/Staff of Kwan.030ab7b7.jpg";